{
  "name": "arctic",
  "ramps": {
    "ground": ["#8AA2C0", "#B2C6DA", "#D8E4EE", "#F4F8FB"],
    "groundAlt": ["#7C8FA8", "#9FB2C8", "#C3D2E0"],
    "water": ["#1E4A73", "#3F7FA6", "#7FC4D6", "#BFE6EE"],
    "rock": ["#4A4E5C", "#6A6F80", "#8D93A3"],
    "dirt": ["#4B4652", "#6A6470", "#8A8590"],
    "foliage": ["#1F3B36", "#2F5A4B", "#4C7A5E"],
    "timber": ["#4B3A33", "#6E5546", "#927560"],
    "concrete": ["#5A606C", "#7C8390", "#A0A7B2"],
    "roof": ["#39404E", "#525B6B"],
    "uniformUS": ["#8E99A6", "#C2CAD1", "#E8ECEF"],
    "uniformEnemy": ["#3E4236", "#5A5F4E", "#7A8068"]
  },
  "haze": "#C9D6E2",
  "ambientNight": "#1B2340"
}
